export default "__VITE_ASSET__DF3KGir0__"